import { ArrowLeft } from 'lucide-react';

import { TooltipProvider } from '@/components/shadcn/ui/tooltip';
import { cn } from '@/lib/cn';

import { Tooltip } from '../tooltip';

type BreadcrumbProps = {
  label: string;
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
  isFirst?: boolean;
  current?: boolean;
};

export function Breadcrumb({
  label,
  onClick,
  className,
  ariaLabel,
  isFirst = false,
  current = false,
}: BreadcrumbProps) {
  const tooltipContent = (
    <div className="max-w-80 whitespace-pre-wrap break-words">{label}</div>
  );

  if (!onClick) {
    return (
      <TooltipProvider>
        <Tooltip content={tooltipContent}>
          <span
            className={cn(
              'inline-flex min-w-0 items-center gap-1.5 truncate text-sm font-medium text-foreground',
              className,
            )}
          >
            {isFirst && <ArrowLeft className="size-4 shrink-0" />}
            <span className="min-w-0 truncate">{label}</span>
          </span>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip content={tooltipContent}>
        <button
          type="button"
          onClick={onClick}
          aria-label={ariaLabel ?? label}
          className={cn(
            'inline-flex items-center gap-1.5 text-sm transition-colors',
            current
              ? 'font-medium text-foreground'
              : 'text-muted-foreground hover:text-foreground hover:underline underline-offset-4',
            className,
          )}
        >
          {isFirst && <ArrowLeft className="size-4 shrink-0" />}
          <span className="min-w-0 truncate">{label}</span>
        </button>
      </Tooltip>
    </TooltipProvider>
  );
}
